import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './styles.css';
import P from 'prop-types';
import { Cadastro } from '../Cadastro';
import { Detalhes } from '../Detalhes';
import { CadastroClienteRodape } from '../CadastroClienteRodape';
import { Login } from '../Login';
//import { LoginRodape } from '../LoginRodape';
import { RecuperarSenha } from '../RecuperarSenha';
import { Informacoes } from '../Informacoes';
import { InformacaoPagamento } from '../InformacaoPagamento';
import { Mapa } from '../MapaAreaAtendimento';
import { Menu } from '../Menu';
import { Sacola } from '../Sacola';
//import { ToastContainer } from 'react-toastify';
import { Ajuda } from '../Ajuda';
import { ConfirmaSms } from '../ConfirmaSms';
import { ConfirmaSmsRodape } from '../ConfirmaSmsRodape';
import { SacolaMenuEdicao } from '../SacolaMenuEdicao';
import { Finalizacao } from '../Finalizacao';
import { Loading } from '../Loading';
import { FinalizacaoRodape } from '../FinalizacaoRodape';
import { FinalizacaoTroco } from '../FinalizacaoTroco';
import { MeusDados } from '../MeusDados';
import { Enderecos } from '../Enderecos';
import { EnderecoNovo } from '../EnderecoNovo';
import Pedidos from '../Pedidos';
import useWindowDimensions, { PositionPerfilOptionsPopUp } from '../../utils/utils';
import { ListaCartoesCredito } from '../PagamentoOnline/ListaCartoesCredito';
import { Autenticacao } from '../Autenticacao';
import { AutoAtendimento } from '../../templates/AutoAtendimento';
import MenuCategorias from '../MenuCategorias';
import { Conferencia } from '../Conferencia';
import { Procura } from '../Procura';
import { QrCodeReader } from '../QrCodeReader';
import { ExcluirConta } from '../ExcluirConta';
import Confirmacao from '../ModalConfirmacao';

export const Modal = ({
  isFooter,
  btnOnClickClose,
  visibility,
  param,
  title = '',
  page = '',
  formasPagamento,
  customPosition = '',
  onAdded,
}) => {
  const [modalPage, setModalPage] = useState(page);
  const [modalTitle, setModalTitle] = useState(title);
  const [modalParam, setModalParam] = useState(param);
  const { width } = useWindowDimensions();

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    document.getElementById('top').style.zIndex = '90';
    document.getElementById('categorias').style.zIndex = '90';
    if (modalPage != 'MENU') {
      const element = document.querySelector('.modal');
      element.style.marginLeft = '';
      element.style.marginTop = '';
      element.style.display = '';
    } else PositionPerfilOptionsPopUp();

    return () => {
      const temp = document.querySelectorAll('.modal-title');
      if (temp.length === 0) {
        const elemTop = document.getElementById('top');
        if (elemTop) elemTop.style.zIndex = '999';
        const elemCategorias = document.getElementById('categorias');
        if (elemCategorias) elemCategorias.style.zIndex = '999';
        document.body.style.overflow = 'unset';
      }
    };
  }, [page, modalPage]);

  const handleBodyModal = (pageName, pageTitle, paramModal) => {
    setModalTitle(pageTitle);
    setModalPage(pageName);
    setModalParam({ ...paramModal });
  };

  if (modalPage == 'AREA_ATENDIMENTO') customPosition = 'area-atendimento';

  if (modalPage == 'LOGIN' || modalPage == 'RECUPERAR_SENHA') {
    if (width >= 427) customPosition = 'login-modal';
  }

  return createPortal(
    <div style={{ display: visibility }}>
      <div className={`modal-container modal-fade-in ${modalPage == 'MENU' ? 'perfil-options' : ''}`}>
        {/* <ToastContainer enableMultiContainer containerId={'modalToast'} position="top-center" autoClose={2500} /> */}
        <div className={`modal modal-scrollable  ${customPosition != '' ? customPosition : ''}`}>
          {modalPage !== 'LOADING' && modalPage !== 'FINALIZACAO_TROCO' && modalPage !== 'AUTENTICACAO' && (
            <div className="modal-header">
              {/* {modalPage !== 'PROCURA' && <h3 className="modal-title">{modalTitle.toLowerCase()}</h3>} */}
              <h3 className="modal-title">{modalTitle.toLowerCase()}</h3>
              {/* {modalPage === 'PROCURA' && <input type="text" placeholder="ex. coca cola" className="inputTroco" />} */}
              <button onClick={btnOnClickClose} className="modal-close" type="button">
                <i className="material-icons">close</i>
              </button>
            </div>
          )}

          <div className="modal-content" style={{ background: `${modalPage === 'LOADING' ? 'transparent' : '#fff'}` }}>
            {modalPage === 'CADASTRO' && <Cadastro />}
            {modalPage === 'DETALHES' && <Detalhes param={param} closeModal={btnOnClickClose} onAdded={onAdded} />}
            {modalPage === 'SACOLA' && (
              <Sacola param={param} handleModal={handleBodyModal} closeModal={btnOnClickClose} />
            )}
            {modalPage === 'LOGIN' && (
              <Login param={param} handleModal={handleBodyModal} handleClose={btnOnClickClose} />
            )}
            {modalPage === 'RECUPERAR_SENHA' && <RecuperarSenha handleModal={handleBodyModal} />}
            {modalPage === 'INFORMACOES' && <Informacoes handleModal={handleBodyModal} />}
            {modalPage === 'AREA_ATENDIMENTO' && <Mapa param={param} />}
            {modalPage === 'INFO_PAGAMENTO' && <InformacaoPagamento param={formasPagamento} />}
            {modalPage === 'MENU' && <Menu param={param} handleModal={handleBodyModal} handleClose={btnOnClickClose} />}
            {modalPage === 'AJUDA' && <Ajuda handleModal={handleBodyModal} />}
            {modalPage === 'SMS' && <ConfirmaSms handleClose={btnOnClickClose} modalParam={param} />}
            {modalPage === 'EXCLUIR_CONTA' && <ExcluirConta handleClose={btnOnClickClose} modalParam={param} />}
            {modalPage === 'SACOLA_MENU_EDICAO' && <SacolaMenuEdicao param={param} closeModal={btnOnClickClose} />}
            {modalPage === 'CONFIRMACAO' && <Confirmacao param={param} closeModal={btnOnClickClose} />}
            {modalPage === 'FINALIZACAO' && <Finalizacao param={param} closeModal={btnOnClickClose} />}
            {modalPage === 'FINALIZACAO_RODAPE' && <FinalizacaoRodape param={param} closeModal={btnOnClickClose} />}
            {modalPage === 'FINALIZACAO_TROCO' && <FinalizacaoTroco param={param} closeModal={btnOnClickClose} />}
            {modalPage === 'AUTENTICACAO' && <Autenticacao param={param} closeModal={btnOnClickClose} />}
            {modalPage === 'QR_CODE' && <QrCodeReader param={param} closeModal={btnOnClickClose} />}
            {modalPage === 'LOADING' && <Loading param={param} closeModal={btnOnClickClose} />}
            {modalPage === 'MEUS_DADOS' && <MeusDados handleModal={handleBodyModal} closeModal={btnOnClickClose} />}
            {modalPage === 'ENDERECOS' && <Enderecos handleModal={handleBodyModal} param={param} />}
            {modalPage === 'OPCAO_AUTO_ATENDIMENTO' && <AutoAtendimento handleModal={handleBodyModal} param={param} />}
            {modalPage === 'PROCURA' && <Procura handleModal={handleBodyModal} param={param} />}
            {modalPage === 'MENU_CATEGORIAS' && <MenuCategorias handleModal={handleBodyModal} param={param} />}
            {modalPage === 'CONFERENCIA' && <Conferencia handleModal={handleBodyModal} param={param} />}
            {modalPage === 'NOVO_ENDERECO' && (
              <EnderecoNovo handleModal={handleBodyModal} param={param} modalParam={modalParam} />
            )}
            {modalPage === 'PEDIDOS' && <Pedidos handleModal={handleBodyModal} param={param} />}
            {modalPage === 'LISTA_CARTOES' && <ListaCartoesCredito handleModal={handleBodyModal} param={param} />}
          </div>

          {isFooter && (
            <>
              {modalPage === 'SMS' && (
                <div className="modal-footer">
                  <ConfirmaSmsRodape />
                </div>
              )}
              {modalPage === 'CADASTRO' && (
                <div className="modal-footer">
                  <CadastroClienteRodape param={param} handleBodyModal={handleBodyModal} />
                </div>
              )}
              {/* {modalPage === 'LOGIN' && (
                <div className="modal-footer">
                  <LoginRodape handleBodyModal={handleBodyModal} />
                </div>
              )} */}
            </>
          )}
        </div>
        <div
          className={`${modalPage === 'LOADING' ? 'modal-overlay-transparent' : 'modal-overlay'}`}
          onClick={btnOnClickClose}
        ></div>
      </div>
    </div>,
    document.body,
  );
};

Modal.propTypes = {
  isFooter: P.bool,
  btnOnClickClose: P.func,
  visibility: P.string,
  param: P.object,
  title: P.string.isRequired,
  page: P.string.isRequired,
  formasPagamento: P.object,
  customPosition: P.string,
  onAdded: P.func,
};
